<template>
    <div
        v-outsideclick="closeModal"
        :class="['base-select', open ? 'open' : '']"
    >
        <div class="select-display" @click="toggleDropdown">
            <span class="iconfont icon-time"></span>
            <p :class="[selectedLabel ? 'label' : 'placeholder']">
                {{ selectedLabel || placeholder }}
            </p>
            <span class="iconfont icon-small-down"></span>
        </div>

        <!-- PC 端下拉菜单 -->
        <ul v-if="open && !isMobileSize" class="dropdown-menu">
            <li
                v-for="option in options"
                :key="option[valueKey]"
                @click="selectOption(option)"
                :class="{ selected: option[valueKey] === modelValue }"
            >
                {{ option[labelKey] }}
            </li>
        </ul>

        <!-- 移动端底部弹出模态框 -->
        <div
            v-if="open && isMobileSize"
            class="modal-overlay"
            @click="closeModal"
        >
            <div class="modal-content" @click.stop>
                <div class="modal-header">
                    <h3>{{ placeholder }}</h3>
                    <span
                        class="iconfont icon-close"
                        @click="closeModal"
                    ></span>
                </div>

                <!-- 选项列表 -->
                <ul class="modal-options">
                    <li
                        v-for="option in options"
                        :key="option[valueKey]"
                        @click="selectOption(option)"
                        :class="{ selected: option[valueKey] === modelValue }"
                    >
                        {{ option[labelKey] }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CustomSelect',
    props: {
        modelValue: {
            type: [String, Number],
            default: ''
        },
        options: {
            type: Array,
            required: true
        },
        valueKey: {
            type: String,
            default: 'value'
        },
        labelKey: {
            type: String,
            default: 'label'
        },
        placeholder: {
            type: String,
            default: 'Please select an option'
        }
    },
    data() {
        return {
            open: false
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        selectedLabel() {
            const selectedOption = this.options.find(
                option => option[this.valueKey] === this.modelValue
            );
            return selectedOption ? selectedOption[this.labelKey] : '';
        }
    },
    emits: ['update:modelValue'],
    methods: {
        toggleDropdown() {
            this.open = !this.open;
        },
        selectOption(option) {
            this.$emit('update:modelValue', option[this.valueKey]);
            this.$emit('change', option[this.valueKey]);
            this.closeModal();
        },
        closeModal() {
            this.open = false;
        }
    }
};
</script>

<style lang="scss">
.base-select {
    position: relative;
    .icon-small-down {
        font-size: 24px;
        transition: transform 0.3s ease;
    }
    &.open {
        .icon-small-down {
            transform: rotate(180deg);
        }
    }
}

.select-display {
    padding: 10px;
    width: 100%;
    height: 36px;
    border: 1px solid rgba(218, 218, 218, 0.5);
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 1.2;
    & > p {
        flex: 1;
        margin: 0 10px;
    }
    .iconfont {
        color: var(--g-tip-color);
    }
    .label {
        color: var(--g-primary-color);
    }
    .placeholder {
        color: var(--g-tip-color);
    }
}

.dropdown-menu {
    position: absolute;
    background: var(--g-bg-color);
    width: 100%;
    max-height: 280px;
    overflow-y: auto;
    z-index: 1000;
    box-shadow: 0px 2px 5px 0px rgba(25, 25, 25, 0.1);
    border: 1px solid rgba(218, 218, 218, 0.5);

    li {
        color: var(--g-text-color);
        font-size: 16px;
        line-height: 40px;
        padding: 0 10px;
        cursor: pointer;
        &.selected,
        &:hover {
            background-color: rgba(218, 218, 218, 0.2);
        }
    }
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    width: 100%;
    background: var(--g-bg-color);
    color: var(--g-primary-color);
    position: relative;
}

.modal-header {
    padding: 20px 20px 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h3 {
        font-size: 16px;
        line-height: 1.2;
        font-weight: 700;
    }
    .icon-close {
        font-size: 14px;
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
        transform: translate3d(0, 0, 0);
    }
}

.modal-options {
    max-height: 60vh;
    overflow-y: auto;
    li {
        font-size: 15px;
        line-height: 1.2;
        padding: 15px;
        cursor: pointer;
        border-bottom: 1px solid rgba(218, 218, 218, 0.5);
        &.selected,
        &:hover,
        &:focus {
            font-weight: 700;
            color: var(--g-btn-background);
        }
    }
}
</style>
